import { Flex, FlexProps, forwardRef } from '@chakra-ui/react';
import { Map } from './Map';

interface Props extends Omit<FlexProps, 'content'> {
  outlets: AdaptedStore[];
  content: OutletsMapContent;
}

export const OutletsMap = forwardRef<Props, 'div'>((props, ref) => {
  const { outlets, content, children, ...rest } = props;

  return (
    <Flex
      ref={ref}
      h={['70vh', '70vh', 'calc(100vh - 5rem)']}
      w="100vw"
      overflow="hidden"
      pos="relative"
      boxShadow="lg"
      {...rest}
    >
      <Map outlets={outlets} content={content}>
        {children}
      </Map>
    </Flex>
  );
});
